import ActionButton from '@repo/ui/action-button'
import { DeleteIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'

import { unassignJourneyFromRad } from '../../../api/rads/unassign-journey'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

interface UnassignJourneyFromRadButtonProps {
  id: number
  journeyId: number
  onSuccess: () => void
}

const UnassignJourneyFromRadButton = ({
  id,
  journeyId,
  onSuccess
}: UnassignJourneyFromRadButtonProps) => {
  const unassignJourneysMutation = useMutation({
    mutationFn: unassignJourneyFromRad,
    onError: showAxiosError,
    onSuccess
  })

  return (
    <ActionButton
      icon={DeleteIcon}
      isLoading={unassignJourneysMutation.isPending}
      variant="danger"
      onClick={() =>
        unassignJourneysMutation.mutate({
          id,
          journeyId
        })
      }
    />
  )
}

export default UnassignJourneyFromRadButton
